import { receiptsAPI } from '@matix/api-client';
import { useCart } from '../../store/cart';
import { useHeldOrders } from '../../store/heldOrders';
import { useUI } from '../../store/ui';
import { toast } from '../../store/toast';

type Tr = (m: { en: string; ar: string }) => string;

/**
 * Load a HELD invoice (IsHolded = 1) into the cart — from the Held Orders
 * screen, or from a table held by it on the table picker (the legacy till's
 * `ReservedTableClick` → `LoadDineInOrder`). The cart comes back on its table;
 * Charge then pays that same invoice and Hold saves changes onto it.
 * With `pay`, the payment modal opens at once. Resolves true when opened.
 */
export async function openHeldOrder(id: number, opts: { pay: boolean; tr: Tr }): Promise<boolean> {
  const { tr } = opts;
  const cart = useCart.getState();
  if (cart.lines.length > 0 && cart.editingReceiptId !== id) {
    const ok = window.confirm(
      tr({
        en: 'The cart has items. Replace them with this held order?',
        ar: 'السلة بها أصناف. هل تريد استبدالها بهذا الطلب المعلق؟',
      }),
    );
    if (!ok) return false;
  }
  try {
    const detail = await receiptsAPI.getById(id);
    if (!detail.is_holded || detail.is_canceled) {
      toast(
        tr({
          en: 'This order is no longer held — it was paid or cancelled.',
          ar: 'لم يعد هذا الطلب معلقاً — تم دفعه أو إلغاؤه.',
        }),
        'warning',
      );
      void useHeldOrders.getState().refresh();
      return false;
    }
    useCart.getState().hydrateFromReceipt(detail);
    useUI.getState().setTab('walkin');
    if (opts.pay) useUI.getState().showModal('payment');
    return true;
  } catch (err) {
    toast(err instanceof Error ? err.message : 'Failed to load the held order', 'error');
    return false;
  }
}
